import React from "react";
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import { Parallax, Background } from 'react-parallax';

import HtmlContent from "../../../../base/components/html_content.js";

import PatternLeft from "../resources/svgs/pattern_left.svg";
import PatternLeftMobile from "../resources/svgs/pattern_left_mobile.svg";
import PatternRight from "../resources/svgs/pattern_right.svg";
import PatternRightMobile from "../resources/svgs/pattern_right_mobile.svg";

const blockStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.white,
    textAlign: "center",
    backgroundColor: theme.palette.blueMain,
    overflow: "hidden"
  },
  background: {
    width: "100vw"
  },
  parallaxContent: {
    padding: "28px 280px 32px",
    ['@media (max-width: 992px)']: {
      padding: "24px 280px 28px",
    },
    ['@media (max-width: 768px)']: {
      padding: "22px 56px",
    },
  },
  pattern: {
    position: "absolute",
    top: "0px",
    bottom: "0px",
    width: "288px",
    backgroundSize: "288px auto",
    backgroundRepeat: "repeat",
    height: "150vh",
    ['@media (max-width: 992px)']: {
      width: "200px",
      backgroundSize: "200px auto",
    },
    ['@media (max-width: 768px)']: {
      width: "42px",
      backgroundSize: "42px auto",
    },
  },
  left: {
    backgroundImage: `url(${PatternLeft})`,
    left: "-30px",
    ['@media (max-width: 992px)']: {
      left: "-20px",
    },
    ['@media (max-width: 768px)']: {
      left: "0px",
      backgroundImage: `url(${PatternLeftMobile})`,
    },
  },
  right: {
    backgroundImage: `url(${PatternRight})`,
    right: "-30px",
    backgroundPositionY: "-68px",
    ['@media (max-width: 992px)']: {
      right: "-20px",
    },
    ['@media (max-width: 768px)']: {
      right: "0px",
      backgroundImage: `url(${PatternRightMobile})`,
      backgroundPositionY: "0px",
    },
  },
  textContainer: {
    width: "100%",
  },
  title: {
    display: "block",
    fontSize: "38px",
    textTransform: "uppercase",
    ['@media (max-width: 992px)']: {
      fontSize: "26px",
    },
    ['@media (max-width: 768px)']: {
      fontSize: "18px",
      lineHeight: "22px"
    },
  },
  text: {
    display: "block",
    fontWeight: theme.typography.fontWeightLight,
    fontSize: "20px",
    marginTop: "30px",
    ['@media (max-width: 992px)']: {
      marginTop: "24px",
      fontSize: "16px",
    },
    ['@media (max-width: 768px)']: {
      marginTop: "16px",
      fontSize: "11px",
      lineHeight: "14px"
    },
  }
}));

const SeparatorBlock = (props) => {
  const classes = blockStyles();
  const { title, text } = props;

  return (
    <div className = { classes.root }>
      <Parallax contentClassName = { classes.parallaxContent }
                strength = { 600 }>
        <Background className = { classes.background }>
          <div className = { clsx(classes.pattern, classes.left) } />
          <div className = { clsx(classes.pattern, classes.right) } />
        </Background>
        <div className = { classes.textContainer } >
          {
            title &&
            <HtmlContent className = { classes.title } >
              { title }
            </HtmlContent>
          }
          {
            text &&
            <HtmlContent className = { classes.text } >
              { text }
            </HtmlContent>
          }
        </div>
      </Parallax>
    </div>
  )
}

export default SeparatorBlock;
